'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const relation = document.querySelector('#splide-relation');

  if(relation) {
    new Splide(relation, {
      perMove: 1,
      perPage: 1,
      gap: 8,
      arrows: false,
      pagination: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 2,
          gap: 24,
          autoWidth: false,
          drag: false,
        }
      }
    }).mount();
  }

  const brands = document.querySelector('#brands-slider');

  if(brands) {
    new Splide(brands, {
      perMove: 1,
      perPage: 1,
      gap: 8,
      arrows: false,
      pagination: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true,
        }
      }
    }).mount();
  }

  const slotsBig = document.querySelector('.slider-big');
  const slotsSmall = document.querySelector('.slider-small');

  if(slotsBig && slotsSmall) {
    let slotsMain = new Splide(slotsBig, {
      type: 'fade',
      pagination: false,
      arrows: false,
    });

    var slotsThumbnails = new Splide(slotsSmall, {
      loop: true,
      isNavigation: true,
      pagination: true,
      gap: 8,
      perMove: 1,
      perPage: 2,
      mediaQuery: 'min',
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
      breakpoints : {
        768: {
          perPage: 3
        },
        960: {
          perPage: 4
        },
      },
    });

    slotsMain.sync( slotsThumbnails );
    slotsMain.mount();
    slotsThumbnails.mount();
  }
});